import { useEffect, useState } from "react";
import PageHeader from "../../components/common/pageHeader/PageHeader";
import { ValueCard } from "../../components/common/tiles/ValueCard";
import Wrapper from "../../components/utils/Wrapper";
import { Data } from "../../utils/Data";
import colorArray, {
  articleLineColorArray,
  overviewTileLineColorArray,
} from "../../utils/JSON/colorArray";
import useScreenHook from "../../utils/helperFunctions/useScreenHook";
import { Link, useLocation } from "react-router-dom";
import getFormatedDate from "../../utils/helperFunctions/formatedDate";
import GorillaSvg from "../../assets/GorillaSvg";
import OnlyGorillaIcon from "../../assets/OnlyGorillaIcon";
import sanitizeHtml from "../../utils/UI/sanitizeHtml";
import getFormatNumber from "../../utils/helperFunctions/getFormatedNumber";

// const dummySourceIcon =
//   "https://img.freepik.com/premium-vector/green-j-letter-alphabet-vector-logo_635759-469.jpg";
const overviewTilesChartData = Data.map((data) => ({
  x: data.year,
  y: data.userGain,
}));

export default function ArticleInsight() {
  const { deviceType = "desktop" } = useScreenHook();
  const location = useLocation();
  const receivedData = location.state;

  const [articleData, setArticleData] = useState(receivedData);
  const [sentimentData, setSentimentData] = useState({
    value: "Negative",
    cardBackgraound: "linear-gradient(72.11deg, #D52800 0%, #FF0000 100%)",
    line: colorArray[0],
  });

  const renderTrafficText = (mediaType: string) => {
    switch (mediaType) {
      case "digital":
        return "traffic";
      case "tv":
        return "viewers";
      case "radio":
        return "listeners";
      case "print":
        return "circulation";
    }
  };

  const overviewTilesData = [
    {
      chartData: overviewTilesChartData,
      heading: "Distribution",
      subHeading: `${articleData?.country.join(", ")}`,
      description: "",
      customStyle: {
        background:
          "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
        line: overviewTileLineColorArray[0],
      },
      showLineGraph: false,
    },
    {
      chartData: overviewTilesChartData,
      heading: articleData?.size?.label,
      subHeading: `${articleData?.size?.value}`,
      description: "",
      customStyle: {
        background:
          "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
        line: overviewTileLineColorArray[1],
      },
    },
    {
      chartData: overviewTilesChartData,
      heading: "Keywords",
      subHeading: `${articleData?.keywords?.length < 2 ? `${articleData?.keywords}` : `${articleData?.keywords[0]}, ${articleData?.keywords[1]}`}`,
      description: "",
      customStyle: {
        background:
          "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
        line: overviewTileLineColorArray[2],
      },
    },
    {
      chartData: overviewTilesChartData,
      heading: "Language",
      subHeading: `${articleData?.language}`,
      description: "",
      customStyle: {
        background:
          "linear-gradient(215.85deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%)",
        line: overviewTileLineColorArray[3],
      },
    },
  ];
  const articleTilesData = [
    {
      chartData: overviewTilesChartData,
      heading: "Media Value (AVE)",
      subHeading: `$${getFormatNumber(Number(articleData?.ave))}`,
      description: "pr value",
      customStyle: {
        background: "linear-gradient(252.11deg, #E63CCA 0%, #9F0FEF 100%)",
        line: articleLineColorArray[0],
      },
      hideInsight: true,
    },
    {
      chartData: overviewTilesChartData,
      heading: `Estimated ${renderTrafficText(articleData?.mediaType)}`,
      subHeading: `${getFormatNumber(Number(articleData?.traffic))}`,
      description: `estimated ${renderTrafficText(articleData?.mediaType)}`,
      customStyle: {
        background: "linear-gradient(252.11deg, #E63CCA 0%, #9F0FEF 100%)",
        line: articleLineColorArray[0],
      },
      hideInsight: true,
    },
    {
      chartData: overviewTilesChartData,
      heading: "Impressions",
      subHeading: `${getFormatNumber(Number(articleData?.traffic * 3.75))}`,
      description: "total impressions",
      customStyle: {
        background: "linear-gradient(252.11deg, #E63CCA 0%, #9F0FEF 100%)",
        line: articleLineColorArray[0],
      },
      hideInsight: true,
    },
    {
      chartData: overviewTilesChartData,
      heading: "Sentiment Score",
      subHeading: sentimentData?.value || "Negative",
      // description: "Combined Value Generated",
      customStyle: {
        background:
          sentimentData?.cardBackgraound ||
          "linear-gradient(72.11deg, #D52800 0%, #FF0000 100%)",
        line: "#00000000",
      },
      hideInsight: true,
      showLineGraph: false,
    },
  ];

  const sentimentBG = (sentiment: string) => {
    switch (sentiment) {
      case "positive":
        return {
          gradient: "linear-gradient(35.85deg, #129219 0%, #06CD11 100%)",
          line: colorArray[3],
        };
      case "negative":
        return {
          gradient: "linear-gradient(72.11deg, #D52800 0%, #FF0000 100%)",
          line: colorArray[0],
        };

      case "neutral":
        return {
          gradient: "linear-gradient(252.11deg, #3C7BE6 0%, #0048C2 100%)",
          line: colorArray[2],
        };

      default:
        return {
          gradient: "linear-gradient(35.85deg, #129219 0%, #06CD11 100%)",
          line: colorArray[3],
        };
    }
  };

  useEffect(() => {
    if (!receivedData) return;
    setArticleData(receivedData);
  }, [receivedData]);

  useEffect(() => {
    if (!articleData) return;
    const sentiment = articleData?.sentiment?.includes("ONLY")
      ? "Positive"
      : articleData?.sentiment || "Negative";
    const { gradient, line } = sentimentBG(sentiment?.toLowerCase());
    setSentimentData({
      value: sentiment,
      cardBackgraound: gradient,
      line: line,
    });
  }, [articleData]);
  return (
    <>
      {/* Heading section */}
      <PageHeader
        heading="Published Article Insights"
        showDateRangeFilter={false}
      />
      {/* tiles section  */}
      <div className="w-full flex overflow-auto gap-3  mt-3 items-center ">
        {articleTilesData.map((item) => (
          <ValueCard
            data={item.chartData}
            title={item.heading}
            value={item.subHeading}
            remark={item.description}
            color={item.customStyle}
            hideInsight={item.hideInsight}
            showLineGraph={item.showLineGraph}
          />
        ))}
      </div>
      <div className="w-full flex overflow-auto gap-3  mt-3 items-center ">
        {overviewTilesData.map((item) => (
          <ValueCard
            data={item.chartData}
            title={item.heading}
            value={item.subHeading}
            remark={item.description ? "" : ""}
            color={item.customStyle}
            hideInsight={true}
            showLineGraph={item.showLineGraph}
            customStyle={{
              remark: {
                fontSize: deviceType === "desktop" ? "18px" : "6px",
                fontWeight: "400",
                lineHeight: "22px",
              },
            }}
          />
        ))}
      </div>
      {/* Article details */}
      <a href={articleData?.link} target="_blank">
        <Wrapper customClass={"md:p-9 p-2 mt-4"} insights={false}>
          <div className="flex flex-col gap-4">
            <div className="flex item-center gap-2">
              <div className="md:w-[50px] md:h-[50px] w-[31px] h-[31px]">
                {articleData?.sourceIcon ? (
                  <img
                    src={articleData?.sourceIcon}
                    alt="Article Logo"
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <div className="flex justify-center items-center w-full h-full">
                    <OnlyGorillaIcon />
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                <span className="text-[#385898] font-semibold md:text-xl text-sm">
                  {articleData?.title}
                </span>
                <span className="text-[#999999] md:text-sm text-[10px]">
                  {articleData?.date && getFormatedDate(articleData?.date)}
                </span>
              </div>
            </div>
            <span className="text-xs text-black">
              {articleData?.description}{" "}
            </span>
          </div>
        </Wrapper>
        <div className="w-full min-h-[430px] bg-black mt-4 flex justify-center items-center">
          <img src={articleData?.img} alt="article" className="max-h-[503px]" />
        </div>
      </a>
    </>
  );
}
